"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '../../../utils/styles/index';

/* ++++++++++ --------------- EXPORT : MESSAGE HOLDER : STYLES --------------- ++++++++++ */

var _default = {
  messageHolder: {
    '& .messages': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      position: 'fixed',
      zIndex: '100000000',
      /// on top of everything
      '&.top': {
        top: '0',
        '& .toastermessages': {
          position: 'absolute',
          top: '100%',
          '&.right': {
            right: 0
          },
          '&.left': {
            left: 0
          }
        }
      },
      '&.bottom': {
        bottom: '0',
        flexDirection: 'column-reverse',
        '& .toastermessages': {
          position: 'absolute',
          bottom: '100%',
          '&.right': {
            right: 0
          },
          '&.left': {
            left: 0
          }
        }
      }
    }
  }
};
exports.default = _default;